import { Delete, Edit, SelectAllOutlined } from "@mui/icons-material";
import React from "react";

export const TableCustom = ({
  columns,
  loading,
  data,
  handleEdit,
  handleDelete,
  className = "",
  handleSelect = null,
  downloadSetting = null,
}) => {
  const formateDate = (dateGiven) => {
    if (dateGiven !== "") {
      const date = new Date(dateGiven);
      const dateFormattedDate = `${date.getFullYear()}/${date.getMonth()}/${date.getDate()} , ${date.getHours()}:${date.getMinutes()}`;
      return dateFormattedDate;
    } else {
      return "";
    }
  };

  const getNestedValue = (obj, path) => {
    return path.split(".").reduce((acc, part) => acc?.[part], obj) ?? "—";
  };

  return (
    <div
      className={`overflow-x-auto bg-slate-100 mt-4 j-[90vh] max-h-[90vh] rounded-xl ${className}`}
    >
      <table className="relative w-full bg-slate-50 ">
        <thead className="sticky top-0 bg-white">
          {columns.map((col) => (
            <th
              key={col.key}
              className={`px-2 py-1 text-center w-[${col.width}]`}
            >
              <p className="flex items-center mx-2 my-1 font-medium text-center justify-left text-xm gap-x-1">
                {col.label}
              </p>
            </th>
          ))}
          {(handleEdit || handleDelete || handleSelect || downloadSetting) && (
            <th className={`px-2 py-1 text-center`}>
              <p className="flex items-center mx-2 my-1 font-medium text-center justify-left text-xm gap-x-1">
                Action
              </p>
            </th>
          )}
        </thead>
        <tbody className="mt-4 divide-y">
          {loading ? (
            <p>Loading...</p>
          ) : (
            data?.data?.map((dt) => {
              return (
                <tr
                  key={dt.id}
                  className="p-2 border-b rounded-xl last:border-b-0 odd:bg-slate-100 even:bg-slate-50"
                >
                  {columns.map((col) => (
                    <td key={col.key} className="px-2 py-1">
                      <p className="flex justify-start w-full mx-2">
                        <span className="text-xs font-medium">
                          {col.Cell
                            ? col.Cell({ row: dt })
                            : col["key"] === "createdOn"
                            ? formateDate(getNestedValue(dt, col["key"]))
                            : `${getNestedValue(dt, col["key"])}`}
                        </span>
                      </p>
                    </td>
                  ))}

                  {(handleEdit ||
                    handleDelete ||
                    handleSelect ||
                    downloadSetting) && (
                    <td className="px-2 py-1">
                      <p className="flex justify-start w-full">
                        <span className="text-base font-medium">
                          {handleEdit && (
                            <Edit
                              className="cursor-pointer"
                              onClick={() => handleEdit(dt.id)}
                            />
                          )}
                          {handleDelete && (
                            <Delete
                              className="cursor-pointer"
                              onClick={() => handleDelete(dt.id)}
                            />
                          )}
                          {handleSelect && (
                            <button
                              className="px-3 py-1 text-sm text-white bg-black rounded-md"
                              onClick={() => handleSelect(dt.id)}
                            >
                              Select
                            </button>
                          )}
                          {downloadSetting && (
                            <button
                              disabled={downloadSetting?.downloadArray?.includes(
                                dt.id
                              )}
                              className="px-3 py-1 text-sm text-white bg-black rounded-md disabled:bg-white disabled:text-black"
                              onClick={() =>
                                downloadSetting?.handleDownload(dt.id)
                              }
                            >
                              {downloadSetting?.downloadArray?.includes(dt.id)
                                ? "Loading"
                                : "Download"}
                            </button>
                          )}
                        </span>
                      </p>
                    </td>
                  )}
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};
